import * as Headless from '@headlessui/react'
import { clsx } from 'clsx'
import { Link } from './link'
import { ReactNode } from 'react'

const variants = {
  primary: clsx(
    'inline-flex items-center justify-center px-4 py-[calc(--spacing(2)-1px)]',
    'rounded-full border border-transparent bg-gray-950 shadow-md',
    'text-base font-medium whitespace-nowrap text-white',
    'data-disabled:bg-gray-950 data-disabled:opacity-40 data-hover:bg-gray-800',
  ),
  secondary: clsx(
    'relative inline-flex items-center justify-center px-4 py-[calc(--spacing(2)-1px)]',
    'rounded-full border border-transparent bg-white/15 ring-1 shadow-md ring-[#D15052]/15',
    'after:absolute after:inset-0 after:rounded-full after:shadow-[inset_0_0_2px_1px_#ffffff4d]',
    'text-base font-medium whitespace-nowrap text-gray-950',
    'data-disabled:bg-white/15 data-disabled:opacity-40 data-hover:bg-white/20',
  ),
  outline: clsx(
    'inline-flex items-center justify-center px-2 py-[calc(--spacing(1.5)-1px)]',
    'rounded-lg border border-transparent ring-1 shadow-sm ring-black/10',
    'text-sm font-medium whitespace-nowrap text-gray-950',
    'data-disabled:bg-transparent data-disabled:opacity-40 data-hover:bg-gray-50',
  ),
}

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'outline'
  className?: string
  href?: string
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  children: ReactNode
}

export function Button({ variant = 'primary', className, href, onClick, type, children, ...props }: ButtonProps) {
  className = clsx(className, variants[variant])

  if (href) {
    return (
      <Link href={href} className={className} {...props}>
        {children}
      </Link>
    )
  }

  if (onClick) {
    return (
      <button onClick={onClick} className={className} type={type || 'button'} {...props}>
        {children}
      </button>
    )
  }

  return (
    <Headless.Button className={className} type={type || 'button'} {...props}>
      {children}
    </Headless.Button>
  )
}

